import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../components/HomePage.vue'
import Applet from '../components/Applet.vue'
import Contact from '../components/Contact.vue'
import AboutMe from '../components/AboutMe.vue'
import Jokes from '../works/Jokes.vue'
import MessageBoard from '../works/MessageBoard.vue'
import MusicPlayer from '../works/MusicPlayer.vue'
import Return from '../components/return.vue'
import SignIn from '../works/SignIn.vue'
import ToDoList from '../works/ToDoList.vue'
Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'HomePage',
		component: HomePage
	},
	{
		path: '/Applet',
		name: 'Applet',
		component: Applet
	},
	{
		path: '/Contact',
		name: 'Contact',
		component: Contact
	},
	{
		path: '/AboutMe',
		name: 'AboutMe',
		component: AboutMe
	},
	{
		path: '/Applet/Jokes',
		name: 'Jokes',
		component: Jokes
	},
	{
		path: '/Applet/MessageBoard',
		name: 'MessageBoard',
		component: MessageBoard
	},
	{
		path: '/Applet/MusicPlayer',
		name: 'MusicPlayer',
		component: MusicPlayer
	},
	{
		path: '/Return',
		name: 'Return',
		component: Return
	},
	{
		path: '/Applet/SignIn',
		name: 'SignIn',
		component: SignIn
	},
	{
		path: '/Applet/ToDoList',
		name: 'ToDoList',
		component: ToDoList
	},
]

const router = new VueRouter({
	// mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
